import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入全局字体样式
import './assets/styles/fonts.scss'

// 使用Element UI
Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')